import { Accessor, Match, Switch } from "solid-js";
import { A } from "@solidjs/router";
import { clientIdConfig } from "~/data/partner_config";
import RNRCodeHubbleBranding from "~/components/login-rnr/rnr_code_hubble_branding";

export function BottomBranding$Client(props: {
  clientId: Accessor<string | undefined>;
}) {
  return (
    <Switch>
      <Match when={props.clientId() === clientIdConfig.tdClientId}>
        <div
          id="rnr-hubble-branding-td"
          class="flex w-full flex-col items-center justify-center border-t border-[#212427] bg-black px-4 py-3"
        >
          <p class="text-center text-bold text-textNormal">
            This portal is created, owned and operated by Gullak Technologies
            Private Limited
          </p>
        </div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.axisClientId || props.clientId() === clientIdConfig.indriyaClientId}>
        <div
          class={`fixed bottom-[-2px] left-0 right-0 z-[20] bg-baseTertiaryLight`}
        >
          <div class=" flex  flex-col items-center justify-center border-t border-baseTertiaryDark py-2 ">
            <RNRCodeHubbleBranding />
            <p class="w-full px-4  text-center text-bold text-textNormal ">
              For any issues/queries, please contact{" "}
              <A
                href="https://application.axisbank.co.in/webforms/axis-support/index.aspx?cta=axis-support-header&_gl=1*b78wag*_gcl_au*MTEzMDMyNTc4Ny4xNzQ4MzQ5NDIz*_ga*MTkyMjQ4MjQ4OS4xNzQ4MzQ5NDI0*_ga_CH41PE7401*czE3NTM5NjE1MTgkbzI1JGcxJHQxNzUzOTYxODI5JGo1OSRsMCRoNDc4OTk4MTAz"
                target="_blank"
                rel="noopener noreferrer"
                class="cursor-pointer underline-offset-2"
              >
                <u>Axis Bank Support</u>
              </A>
              . You can also connect with the Hubble team at
              support@myhubble.money
            </p>
          </div>
        </div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.mastercardIndriyaClientId}>
        <div
          class={`fixed bottom-[-2px] border-t border-baseTertiaryDark left-0 right-0 z-[20] bg-baseTertiaryLight`}
        >
          <div class="flex flex-col items-center justify-center py-2">
            <RNRCodeHubbleBranding />
          </div>
        </div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.iciciIndriyaClientId}>
        <div
          class={`fixed bottom-[-2px] border-t border-baseTertiaryDark left-0 right-0 z-[20] bg-baseTertiaryLight`}
        >
          <div class="flex flex-col items-center justify-center py-2">
            <RNRCodeHubbleBranding />
          </div>
        </div>
      </Match>
      <Match when={true}>
        <div
          class={`fixed bottom-[-2px] left-0 right-0 z-[20] bg-baseTertiaryLight`}
        >
          <div class="flex flex-col items-center justify-center py-2">
            <RNRCodeHubbleBranding />
          </div>
        </div>
      </Match>
    </Switch>
  );
}
